import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import useAuth from '@/hooks/useAuth';
import { useSelector } from 'react-redux';
import getImageUrl from '@/utils/images';

export default function LoginButton({ className }) {
  const [onIcon, setOnIcon] = useState(false);
  const [onMenu, setOnMenu] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const user = useSelector(state => state.Auth.user);
  const [,,{ isAuthenticated } ] = useAuth();

  useLayoutEffect(() => {
    if (!onIcon && !onMenu) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  }, [onIcon, onMenu]);

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setOnIcon(true)}
      onMouseLeave={() => setOnIcon(false)}
    >
      <div>
        <a href={isAuthenticated ? '/account' : '/login'} className={className} aria-label={'Login button'}>
          <img src={getImageUrl('nav/login_icon.svg')} alt={''} />
        </a>
      </div>
      { (showMenu && user?.isAdmin ) && (
        <AdminMenu
          onMouseEnter={() => setOnMenu(true)}
          onMouseLeave={() => setOnMenu(false)}
        >
          <li>
            <a href="/admin/orders">Dashboard</a>
          </li>
        </AdminMenu>
      )}
    </div>
  );
}

const AdminMenu = styled.ul`
  position: absolute;
  top: 20px;
  left: -50%;
  list-style-type: none;
  background: white;
  border: ${({ theme }) => `1px solid ${theme.colors.gray}`};
  color: ${({ theme }) => theme.colors.charcoal};
  li {
    padding: 5px 20px;
  }
`;
